import cyrillicToTranslit from "cyrillic-to-translit-js"
import set from "lodash/set"

export default {
  methods: {
    setTransliterators () {
      const ctt = cyrillicToTranslit()
      this.translitFields.forEach((f) => {
        const keys = Array.isArray(f) ? f : [`${f}.ru`, `${f}.en`]
        this.$watch(keys[0], (v) => {
          set(this, keys[1], ctt.transform(v))
        })
      })
    },
  },
}
